import React, { useEffect, useState, useRef, useImperativeHandle } from 'react';
import { isMobileFun, getPrefixField, createFilePath, convertStylesStringToObject, isVideo } from '../../utils/obj-utils';
import Detailss from '../../elements/InnerPageDetail';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import { Autoplay, Pagination, Navigation } from 'swiper';
import 'swiper/swiper.min.css';
import './style.scss';

export default function index(props) {
  const { fields, setItemIndex } = props;
  const swiperRef = useRef(null);
  const [flag, setFlag] = useState(false);
  const [videoflag, setVideoflag] = useState(false);
  const isMobile = isMobileFun();
  const id = props?.params?.pagename;
  const containerRef = useRef(null);
  const navigationPrevRef = useRef(null);
  const navigationNextRef = useRef(null);
  const [swiperIndex, setSwiperIndex] = useState(0);
  const [colorIndex, setColorIndex] = useState(0);
  const lists = fields?.lists.filter((it) => {
    let iscolorlist = it?.fields?.colorlist && it?.fields?.colorlist.length > 0;
    if (
      it?.fields[`${getPrefixField('bg', isMobile)}`]?.value ||
      (iscolorlist && it?.fields?.colorlist[colorIndex]?.fields[`${getPrefixField('bg', isMobile)}`]?.value)
    ) {
      return it;
    }
  });
  const [isclickNextPrev, setIsclickNextPrev] = useState(false);
  // sectionAction
  useImperativeHandle(props.eventRef, () => {
    if (props.eventRef) {
      return {
        sendEvent
      };
    }
  });
  const sendEvent = () => {
    window.Dmp.sectionAction(id);
    window.navigationIndex = props.fields.navigationIndex.value;
    window.navigationPagename = window.navigationPagenameb = id !== undefined ? id : '';
  };
  const windowhidden = () => {
    document.documentElement.style.overflow = 'hidden';
  };
  const closewindowhidden = () => {
    document.documentElement.style.overflow = 'auto';
    document.documentElement.style.overflowX = 'hidden';
  };
  return (
    <>
      <div className="price_exterior_v5" id={id}>
        <div className="hash"></div>
        <div className={`con con_type${fields?.type?.value}`} ref={containerRef}>
          {lists.length > 0 && (
            <>
              <Swiper
                ref={swiperRef}
                slidesPerView={isMobile ? '1' : fields?.type?.value === '3' ? '2' : fields?.type?.value === '2' ? '3' : 'auto'}
                className="swiper"
                centeredSlides={fields?.type?.value === '3' ? false : true}
                spaceBetween={0}
                loop={isMobile ? false : true}
                initialSlide={0}
                loopAdditionalSlides={2}
                observer={true}
                resizeObserver={true}
                updateOnWindowResize={true}
                modules={[Pagination, Navigation]}
                threshold={isMobile ? false : 70}
                navigation={{
                  prevEl: navigationPrevRef.current,
                  nextEl: navigationNextRef.current,
                  disabledClass: 'disabled'
                }}
                onSwiper={(swiper) => {
                  setTimeout(() => {
                    swiper.params.navigation.prevEl = navigationPrevRef.current;
                    swiper.params.navigation.nextEl = navigationNextRef.current;
                    swiper.navigation.destroy();
                    swiper.navigation.init();
                    swiper.navigation.update();
                  });
                }}
                onSlideChangeTransitionEnd={(e) => {
                  setSwiperIndex(e.activeIndex);
                  setItemIndex && setItemIndex(e.activeIndex);
                }}
                onSlidePrevTransitionEnd={(e) => {
                  if (fields?.swpprevdmp?.value && !isclickNextPrev) {
                    window.Dmp.clickAction(fields?.swpprevdmp?.value);
                  }
                  setIsclickNextPrev(false);
                }}
                onSlideNextTransitionEnd={(e) => {
                  if (fields?.swpnextdmp?.value && !isclickNextPrev) {
                    window.Dmp.clickAction(fields?.swpnextdmp?.value);
                  }
                  setIsclickNextPrev(false);
                }}
              >
                {lists.map((item, index) => {
                  let iscolorlist = item?.fields?.colorlist && item?.fields?.colorlist.length > 0;
                  let isbg =
                    item?.fields[`${getPrefixField('bg', isMobile)}`]?.value ||
                    (iscolorlist && item?.fields?.colorlist[colorIndex]?.fields[`${getPrefixField('bg', isMobile)}`]?.value);
                  let iscolor = iscolorlist && item?.fields?.colorlist[colorIndex]?.fields[`${getPrefixField('bg', isMobile)}`]?.value;
                  let bg = iscolor
                    ? item?.fields?.colorlist[colorIndex]?.fields[`${getPrefixField('bg', isMobile)}`]?.value
                    : item?.fields[`${getPrefixField('bg', isMobile)}`]?.value;
                  let bgstyle = iscolor
                    ? item?.fields?.colorlist[colorIndex]?.fields[`${getPrefixField('bgstyle', isMobile)}`]?.value
                    : item?.fields[`${getPrefixField('bgstyle', isMobile)}`]?.value;
                  let isbigimg =
                    item?.fields[`${getPrefixField('bigimg', isMobile)}`]?.value ||
                    (iscolorlist && item?.fields?.colorlist[colorIndex]?.fields[`${getPrefixField('bigimg', isMobile)}`]?.value);
                  let bigimg = iscolor
                    ? item?.fields?.colorlist[colorIndex]?.fields[`${getPrefixField('bigimg', isMobile)}`]?.value
                    : item?.fields[`${getPrefixField('bigimg', isMobile)}`]?.value;
                  let isvideo =
                    item?.fields[`${getPrefixField('video', isMobile)}`]?.value ||
                    (iscolorlist && item?.fields?.colorlist[colorIndex]?.fields[`${getPrefixField('video', isMobile)}`]?.value);
                  let istvc = item?.fields?.istvc?.value || (iscolorlist && item?.fields?.colorlist[colorIndex]?.fields?.istvc?.value);
                  let video = iscolor
                    ? item?.fields?.colorlist[colorIndex]?.fields[`${getPrefixField('video', isMobile)}`]?.value
                    : item?.fields[`${getPrefixField('video', isMobile)}`]?.value;
                  let istext =
                    item?.fields[`${getPrefixField('text', isMobile)}`]?.value ||
                    (iscolorlist && item?.fields?.colorlist[colorIndex]?.fields[`${getPrefixField('text', isMobile)}`]?.value);
                  let text = iscolor
                    ? item?.fields?.colorlist[colorIndex]?.fields[`${getPrefixField('text', isMobile)}`]?.value
                    : item?.fields[`${getPrefixField('text', isMobile)}`]?.value;

                  return isbg ? (
                    <SwiperSlide className={`item ${index === swiperIndex ? 'on' : ''} ${istvc ? 'tvcitem' : 'notvcitem'}`} key={index}>
                      <div className="item-in">
                        <div className="top">
                          {isbg && <img className="bg" style={convertStylesStringToObject(bgstyle)} src={createFilePath(bg)} alt="广汽本田" />}
                          <span className="nums">
                            {index + 1}/{lists.length}
                          </span>
                          {isbigimg && !istvc && (
                            <div
                              className="zoom"
                              style={convertStylesStringToObject(fields[`${getPrefixField('zoomiconstyle', isMobile)}`]?.value)}
                              onClick={(e) => {
                                setFlag(true);
                                setSwiperIndex(index);
                                windowhidden();
                                window.Dmp.clickAction(item?.fields?.zoomdmp?.value);
                                e.stopPropagation();
                              }}
                            >
                              <img className="icon" src={createFilePath(fields[`${getPrefixField('zoomicon', isMobile)}`]?.value)} alt="广汽本田" />
                            </div>
                          )}
                          {istvc && (
                            <div
                              className="tvcplay"
                              style={convertStylesStringToObject(fields[`${getPrefixField('playiconstyle', isMobile)}`]?.value)}
                              onClick={(e) => {
                                setVideoflag(true);
                                setSwiperIndex(index);
                                window.Dmp.clickAction(item?.fields?.playdmp?.value, isvideo ? createFilePath(video) : '');
                                e.stopPropagation();
                              }}
                            >
                              <img
                                className="icon"
                                src={createFilePath(fields[`${getPrefixField('tvcplayicon', isMobile)}`]?.value)}
                                alt="广汽本田"
                              />
                            </div>
                          )}
                          {isvideo && !istvc && (
                            <div
                              className="play"
                              style={convertStylesStringToObject(fields[`${getPrefixField('playiconstyle', isMobile)}`]?.value)}
                              onClick={(e) => {
                                setVideoflag(true);
                                setSwiperIndex(index);
                                window.Dmp.clickAction(item?.fields?.playdmp?.value, isvideo ? createFilePath(video) : '');
                                e.stopPropagation();
                              }}
                            >
                              <img className="icon" src={createFilePath(fields[`${getPrefixField('playicon', isMobile)}`]?.value)} alt="广汽本田" />
                            </div>
                          )}
                        </div>
                        <div className="in">{istext && <div dangerouslySetInnerHTML={{ __html: text?.replaceHtml() }}></div>}</div>
                        {item?.fields?.colorlist && item?.fields?.colorlist.length > 0 && (
                          <div
                            className="colorlist"
                            style={convertStylesStringToObject(item?.fields[`${getPrefixField('colorliststyle', isMobile)}`]?.value)}
                          >
                            {item?.fields?.colorlist.map((item2, index) => {
                              return (
                                <div
                                  className={`coloritem ${index === colorIndex ? 'on' : ''}`}
                                  key={index}
                                  style={convertStylesStringToObject(item2?.fields[`${getPrefixField('colorstyle', isMobile)}`]?.value)}
                                  onClick={() => {
                                    setColorIndex(index);
                                    window.Dmp.msgAction(item2?.fields?.dmp?.value, item2?.fields?.dmpname?.value);
                                  }}
                                ></div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    </SwiperSlide>
                  ) : (
                    ''
                  );
                })}
              </Swiper>
              <div
                className="next"
                ref={navigationNextRef}
                data-html-item={fields?.nextdmp?.value}
                style={convertStylesStringToObject(fields[`${getPrefixField('nexticonstyle', isMobile)}`]?.value)}
                onClick={() => {
                  setIsclickNextPrev(true);
                }}
              >
                <img className="icon" src={createFilePath(fields[`${getPrefixField('nexticon', isMobile)}`]?.value)} alt="广汽本田" />
              </div>
              <div
                className="prev"
                ref={navigationPrevRef}
                data-html-item={fields?.prevdmp?.value}
                style={convertStylesStringToObject(fields[`${getPrefixField('previconstyle', isMobile)}`]?.value)}
                onClick={() => {
                  setIsclickNextPrev(true);
                }}
              >
                <img className="icon" src={createFilePath(fields[`${getPrefixField('previcon', isMobile)}`]?.value)} alt="广汽本田" />
              </div>
            </>
          )}
        </div>
        {flag && (
          <div className="prop_detail">
            {lists.map((item, index) => {
              let iscolorlist = item?.fields?.colorlist && item?.fields?.colorlist.length > 0;
              let iscolor = iscolorlist && item?.fields?.colorlist[colorIndex]?.fields[`${getPrefixField('bg', isMobile)}`]?.value;
              let bigimgstyle = iscolor
                ? item?.fields?.colorlist[colorIndex]?.fields[`${getPrefixField('bigimgstyle', isMobile)}`]?.value
                : item?.fields[`${getPrefixField('bigimgstyle', isMobile)}`]?.value;
              let isbigimg =
                item?.fields[`${getPrefixField('bigimg', isMobile)}`]?.value ||
                (iscolorlist && item?.fields?.colorlist[colorIndex]?.fields[`${getPrefixField('bigimg', isMobile)}`]?.value);
              let bigimg = iscolor
                ? item?.fields?.colorlist[colorIndex]?.fields[`${getPrefixField('bigimg', isMobile)}`]?.value
                : item?.fields[`${getPrefixField('bigimg', isMobile)}`]?.value;
              let isbigtext =
                item?.fields[`${getPrefixField('bigtext', isMobile)}`]?.value ||
                (iscolorlist && item?.fields?.colorlist[colorIndex]?.fields[`${getPrefixField('bigtext', isMobile)}`]?.value);
              let bigtext = iscolor
                ? item?.fields?.colorlist[colorIndex]?.fields[`${getPrefixField('bigtext', isMobile)}`]?.value
                : item?.fields[`${getPrefixField('bigtext', isMobile)}`]?.value;
              if (swiperIndex === index) {
                return (
                  <React.Fragment key={index}>
                    {isbigimg && <img className="bg" style={convertStylesStringToObject(bigimgstyle)} src={createFilePath(bigimg)} alt="广汽本田" />}
                    <div className="in">
                      {isbigtext && (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: bigtext.replaceHtml()
                          }}
                        ></div>
                      )}
                    </div>
                    <div
                      className="close"
                      style={convertStylesStringToObject(fields[`${getPrefixField('closeiconstyle', isMobile)}`]?.value)}
                      onClick={() => {
                        setFlag(false);
                        closewindowhidden();
                        window.Dmp.clickAction(lists[swiperIndex].fields?.closedmp?.value);
                      }}
                    >
                      <img className="icon" src={createFilePath(fields[`${getPrefixField('closeicon', isMobile)}`]?.value)} alt="广汽本田" />
                    </div>
                  </React.Fragment>
                );
              }
            })}
          </div>
        )}
        {videoflag && (
          <>
            {lists.map((item, index) => {
              let iscolorlist = item?.fields?.colorlist && item?.fields?.colorlist.length > 0;
              let iscolor = iscolorlist && item?.fields?.colorlist[colorIndex]?.fields[`${getPrefixField('bg', isMobile)}`]?.value;
              let detailurl = iscolor ? item?.fields?.colorlist[colorIndex]?.fields?.detailurl?.value : item?.fields?.detailurl?.value;
              if (swiperIndex === index) {
                return (
                  <React.Fragment key={index}>
                    <Detailss routePath={detailurl} close={() => setVideoflag(false)} />
                  </React.Fragment>
                );
              }
            })}
          </>
        )}
      </div>
    </>
  );
}
